import React, { Component } from 'react'
import './EnterPremium.css'
import { BtnPrimary } from '../commons/Buttons'
import { ControlInput } from '../commons/Controls'

class EnterPremium extends Component {
  constructor (props) {
    super(props)
    this.state = {
      code: '',
      error: null
    }
    this.onSubmit = this.onSubmit.bind(this)
  }
  onSubmit () {
    this.setState({
      error: true
    })
  }
  render () {
    return (
      <div className='enter-premium'>
        <h2>Quiniela Premium</h2>
        <p>Estas quinielas están restringidas solo para usuarios que cuenten con un código de acceso otorgado por un coordinador.</p>
        <p>¿Dudas o quieres más información? pregunta en nuestra sección de contacto.</p>
        <div className='enter-premium__input'>
          <ControlInput
            label='Código'
            type='text'
            value={this.state.code}
            placeholder='Código de acceso para entrar al grupo'
            onChange={(ev) => this.setState({ code: ev.target.value, error: null })}
            error={this.state.error}
          />
          {this.state.error && <div className='error'>El código de acceso tiene error o no existe en nuestra plataforma.</div>}
        </div>
        <div className='enter-premium__footer'>
          <BtnPrimary onClick={this.onSubmit}>Acceder</BtnPrimary>
        </div>
      </div>
    )
  }
}

export default EnterPremium
